import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VisitorBookingListLayer from "../components/VisitorBookingListLayer";

const VisitorBookingListPage = () => {
    return (
        <MasterLayout>
            <VisitorBookingListLayer />
        </MasterLayout>
    );
};

export default VisitorBookingListPage;
